/**
 * The published round calendar — GENERATED from the FM-0013 KERNEL model. Do not edit.
 *
 * Updated: 2026-10-12
 *
 * The closing-date timer renders from this file. One source of truth for a date is what stops
 * the blog, the deck and the dashboard from disagreeing about the same deadline.
 *
 * WHAT IS HERE, AND WHAT IS DELIBERATELY NOT
 *  - Publishes the FIRST close of the round in force: its amount and its date.
 *  - Publishes the dates of later rounds, because a visible schedule is the mechanism.
 *  - Does NOT publish this round's FINAL close. That is the oversubscription budget: keeping
 *    it private lets the round flex upward without re-announcing a total.
 *  - Does NOT publish any valuation, cap, equity percentage or return figure. Ever. A
 *    valuation is a private deal term, and `verify:disclosure` fails the build if one
 *    reaches a public artefact.
 */
export const ROUND_ANNOUNCEMENT = {
  /** The first close, announced publicly with a date. */
  firstCloseAmount: 350000,
  firstCloseDate: "2026-11-15",
  /**
   * When the next round's dates are announced: at this round's FIRST close, not its final one.
   * Announcing the next round seven months before it opens is the whole point of the mechanic.
   */
  nextRoundAnnouncedAt: "2026-11-15",
  /**
   * True when capacity beyond the announced first close exists but is not published. The
   * reader is told that the round can take more, not how much — which is the honest version of
   * an oversubscription budget.
   */
  hasUnpublishedCapacity: true,
} as const;

/**
 * The published calendar. Rounds whose dates are not yet announced are omitted rather than
 * shown blank, and a hidden tranche never appears.
 */
export const ROUND_CALENDAR: Array<{
  id: string;
  name: string;
  opens: string;
  firstClose: string;
  finalClose: string;
  indicative: boolean;
}> = [
  { id: "R1", name: "Pre-seed round (this round)", opens: "2026-10-01", firstClose: "2026-11-15", finalClose: "", indicative: false },
  { id: "R2", name: "Seed round", opens: "2027-06-01", firstClose: "2027-10-31", finalClose: "2027-11-30", indicative: false },
  { id: "R3", name: "Series A", opens: "2029-01-15", firstClose: "2029-04-30", finalClose: "2029-06-30", indicative: true },
];
